<template>
  <div>
    <Notification :notify="notify" />
    <div>
      <div class="row">
        <div class="col">
          <ConfirmationDialog ref="confirm" />
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Publishers</th>
                  <th style="width: 100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.sender }}</td>
                  <td>
                    <v-icon class="mr-2" @click="onSelect(item)"
                      >mdi-view-grid-outline</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "PublisherList",
  props: {
    //userId: { type: Number, required: true },
  },
  watch: {},
  components: {
    Notification,
    ConfirmationDialog,
  },
  created() {
    this.getPublisherList();
  },
  methods: {
    getPublisherList() {
      this.list = [];
      new Promise((resolve, reject) => {
        api
          .getAll("import/onix/providers")
          .then((response) => {
            console.log(response);
            this.list = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelect(obj) {
      console.log(obj);
      this.$emit("onSelect", obj);
    },
  },
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/PublisherList.vue